import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useCreateLetter = () => {
  const queryClient = useQueryClient();

  const handleNetworkError = useHandleNetworkError(
    "Error while creating letter"
  );

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (letterData) => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/patientletter`,
        letterData
      );
      return response.data;
    },
    onSuccess: () => {
      toast.success("Letter saved successfully!");
      queryClient.invalidateQueries({ queryKey: ["activeConsultation"] });
      queryClient.invalidateQueries({ queryKey: ["activeConsultationLetter"] });
    },
    onError: handleNetworkError,
  });
};
